/*
* Created on Mar 03, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useEffect, useState} from 'react';
import * as ReactDom from "react-dom";
import {useTranslation} from "react-i18next";
import {convert_error_code} from "../../../service/common";

const ModelWizardComponent = ({title, children, wizard_data, isOpen, onClose, disPatcher, modalSize='large'}) => {
    const {t} = useTranslation();
    const [showAlert, setShowAlert] = useState(false);
    // alert-info / alert-error / alert-success / alert-warning
    const [showAlertType, setShowAlertType] = useState('info');
    const [message, setMessage] = useState('');
    const [disable, setDisable] = useState(true);

    const alert = (show, type, code, message, auto_hide=0, opts={}) => {
        setShowAlert(show);
        setShowAlertType(type);
        if ( type === 'error') {
            setMessage(t(convert_error_code(code, message), opts));
        }
        else {
            setMessage(t(message));
        }
        if (auto_hide > 0) {
            window.setTimeout(()=>{
                setShowAlert(false);
            }, auto_hide);
        }
    }

    const next = () => {
        if ( wizard_data.steps[wizard_data.current_step].hasOwnProperty('next_action') ) {
            wizard_data.steps[wizard_data.current_step].next_action(alert);
            // disPatcher({type: wizard_data.steps[wizard_data.current_step].next_action})
        }
        else {
            disPatcher({type: 'next', payload: {alert}});
        }
        setDisable(true);
    }

    const prev = () => {
        if ( wizard_data.steps[wizard_data.current_step].hasOwnProperty('prev_action') ) {
            wizard_data.steps[wizard_data.current_step].prev_action(()=>{disPatcher({type: 'prev'})});
        }
        else {
            disPatcher({type: 'prev', payload: {alert}});
        }
    }

    useEffect(()=>{
        disPatcher({type: 'setAlertFunction', payload: {alert}});
    }, []);

    useEffect(()=>{
        if (isOpen === false) {
            return null;
        }
    });

    useEffect(() => {
        if (wizard_data.steps[wizard_data.current_step].hasOwnProperty('next_action_validation')) {
            setDisable(!wizard_data.steps[wizard_data.current_step].next_action_validation(wizard_data));
        }
    }, [wizard_data]);

    return ReactDom.createPortal(
        <>
            {isOpen && <div className="screen-mask visible"/> }
            {isOpen && <div className="dialog-wrapper">
                <div className={`dialog dialog-${modalSize}`}>
                    <div className="dialog-header">
                        <div className="header-title">{title}</div>
                        <div className="close" onClick={onClose}/>
                    </div>

                    <div className="dialog-body">
                        <div className={`dialog-inner-alert alert-${showAlertType} ${showAlert ? '' : 'hide'}`}>
                            <div className="alert-content">
                                <button type="button" className="alert-close-btn" aria-hidden="true" onClick={()=>setShowAlert(false)}>×</button>
                                <div className="alert-msg">
                                    {message}
                                </div>
                            </div>
                        </div>

                        <div className="step-group">
                            {
                                wizard_data.steps?.length > 0 &&
                                wizard_data.steps.map((step, index)=>{
                                    return (
                                        <div className={`step ${wizard_data.current_step === index ? 'active' : ''}`} key={index}>
                                            <div className="step-num">
                                                <span>{index + 1}</span>
                                            </div>
                                            {wizard_data.current_step === index && <div className="step-label">{step.label}</div>}
                                        </div>
                                    )
                                })
                            }
                        </div>
                        {children}
                    </div>


                    <div className="dialog-footer clear">
                        <div className="pull-left">
                            <div className="q-btn-group">
                                <button type="button" className="q-btn q-btn-default" onClick={onClose}>{t('@Cancel@')}</button>
                            </div>
                        </div>
                        <div className="pull-right">
                            <div className="q-btn-group">
                                {wizard_data.steps[wizard_data.current_step].prev_button_label &&
                                    <button type="button" className="q-btn q-btn-default" onClick={prev}>{wizard_data.steps[wizard_data.current_step].prev_button_label}</button>
                                }
                                <button type="button" className="q-btn q-btn-primary" disabled={disable} onClick={next}>{wizard_data.steps[wizard_data.current_step].next_button_label}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}

        </>,
        document.getElementById('modal-dialog')
    );
};

export default ModelWizardComponent;